import { useCallback } from 'react';
import { playPracticeSound } from '../services/soundEffects';

export default function useAnswerFeedbackAudio(enabled) {
  return useCallback(choice => {
    if (!enabled || document.hidden || !['ok', 'no'].includes(choice)) return;
    void playPracticeSound(choice === 'ok' ? 'answerOk' : 'answerNo', { recoverOnGesture: true });
  }, [enabled]);
}
